import { render, staticRenderFns } from "./ShowSearchProducts.vue?vue&type=template&id=150f7c63&scoped=true&"
import script from "./ShowSearchProducts.vue?vue&type=script&lang=js&"
export * from "./ShowSearchProducts.vue?vue&type=script&lang=js&"
import style0 from "./ShowSearchProducts.vue?vue&type=style&index=0&id=150f7c63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f7c63",
  null
  
)

export default component.exports